import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Select, Switch } from 'antd';
import React, { FC } from 'react';
import { GroupFieldInputTypes, STEP_INPUT_TYPE_MAP } from '../../../utils/TroubleshootingUtils';
import TroubleshootingMultipleChoiceField from './TroubleshootingMultipleChoiceField';

const TroubleshootingGroupField: FC<any> = ({ form }): React.ReactElement => {
	return (
		<Form.List name="groupFields">
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name, ...restField }) => (
						<div key={key} className="flex flex-col gap-2">
							<Form.Item
								{...restField}
								style={{ width: '100%' }}
								name={[name, 'label']}
								label="Title"
								rules={[{ required: true, message: 'Missing Value' }]}
							>
								<Input
									style={{ width: '100%' }}
									placeholder={`Title`}
									suffix={
										<DeleteOutlined style={{ cursor: 'pointer' }} onClick={() => remove(name)} />
									}
								/>
							</Form.Item>
							<Form.Item
								label={
									<div
										className="flex w-full flex-row items-center justify-between"
										style={{ width: 600, maxWidth: 600 }}
									>
										<span>Input</span>
										<div className="flex flex-row items-center">
											<span className={`mr-2`}>Input Mandatory?</span>
											<Form.Item name={[name, 'required']} valuePropName="checked" noStyle>
												<Switch defaultChecked={false} size="small" />
											</Form.Item>
										</div>
									</div>
								}
								name={[name, 'inputType']}
								rules={[{ required: true, message: 'Please select input type' }]}
							>
								<Select placeholder="None">
									{GroupFieldInputTypes.map((f) => (
										<Select.Option key={f.value} value={f.value}>
											{f.label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Form.Item shouldUpdate noStyle>
								{({ getFieldValue }) => {
									const inputType = getFieldValue(['groupFields', name, 'inputType']);
									if (inputType === STEP_INPUT_TYPE_MAP.MULTIPLE_CHOICE) {
										return (
											<TroubleshootingMultipleChoiceField isGroupField name={[name, 'options']} />
										);
									}
									return null;
								}}
							</Form.Item>
							<div className="my-4 h-px w-full bg-[#D9D9D9]" />
						</div>
					))}
					<Form.Item>
						<Button type="link" onClick={() => add()} icon={<PlusOutlined />}>
							Add Field
						</Button>
					</Form.Item>
				</>
			)}
		</Form.List>
	);
};

export default TroubleshootingGroupField;
